var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLiveClassLg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1814 9C22.8426 9 25 11.1925 25 13.8971V26.1029C25 28.8075 22.8426 31 20.1814 31H7.81861C5.15737 31 3 28.8075 3 26.1029V13.8971C3 11.1925 5.15737 9 7.81861 9H20.1814Z",
    fill: "#567FFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1056 13.4472L28.1056 16.4472C27.428 16.786 27 17.4785 27 18.2361V21.7639C27 22.5215 27.428 23.214 28.1056 23.5528L34.1056 26.5528C35.4354 27.2177 37 26.2507 37 24.7639V15.2361C37 13.7493 35.4354 12.7823 34.1056 13.4472Z",
    fill: "#567FFB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveClassLg);
export default __webpack_public_path__ + "static/media/live-class-lg.620445292eeb2c1d61730f9860bda33c.svg";
export { ForwardRef as ReactComponent };